import React from 'react';
import { Box } from '@mui/material';
import { USAJILIPvtToDateTab } from './USAJILIPvtToDateTab';
import { USAJILIPvtTrendTab } from './USAJILIPvtTrendTab';

/** Page 2 — Pivot table: voters by date × county, then county × metric totals. */
export const USAJILIPivotTab: React.FC = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
    <USAJILIPvtToDateTab />
    <USAJILIPvtTrendTab />
  </Box>
);
